import { render } from "./EntraTenantOverview.vue?vue&type=template&id=447af080&scoped=true"
import script from "./EntraTenantOverview.vue?vue&type=script&lang=js"
export * from "./EntraTenantOverview.vue?vue&type=script&lang=js"

import "./EntraTenantOverview.vue?vue&type=style&index=0&id=447af080&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-447af080"]])

export default __exports__